import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Asks the nutritionist if they want to enable automatic reminders for a given kind
 * ('meals' or 'supplements') right after creating that resource. Only shows the toast
 * if the patient does NOT yet have that reminder type enabled.
 */
export async function promptEnableReminders(patientId, kind) {
  if (!patientId || !kind) return;
  try {
    const { data: prefs } = await axios.get(`${API}/api/patients/${patientId}/notification-preferences`);
    if (prefs?.[kind]?.enabled) return; // already on
    const labels = {
      meals: 'lembretes de refeições',
      supplements: 'lembretes de suplementação',
    };
    toast(`Queres ativar ${labels[kind] || 'lembretes automáticos'} para esta paciente?`, {
      duration: 8000,
      action: {
        label: 'Ativar',
        onClick: async () => {
          try {
            await axios.put(`${API}/api/patients/${patientId}/notification-preferences`, { [kind]: { ...(prefs[kind] || {}), enabled: true } });
            toast.success('Lembretes ativados');
          } catch {
            toast.error('Erro ao ativar lembretes');
          }
        },
      },
    });
  } catch {
    // Silent — preferences fetch failed; don't bother the user
  }
}
